export default class DropdownRenderer {

    constructor(parent, onChangeCb) {

        this.config = parent.config;

        this.render = (dropdownOptions) => {
            parent.innerHTML = `
                            <select class="list-element ${this.config.className}" id="select-${this.config.level}">
                            <option data-id="" value="">${this.config.placeholder}</option>
                            ${dropdownOptions}
                            </select>
                        `;

            this.listElement = parent.querySelector(".list-element");
            this.listElement.addEventListener("change", e => {
                e.preventDefault();
                e.stopImmediatePropagation();

                const selectedOption = this.listElement.querySelector(`[value="${e.target.value}"]`);
                onChangeCb(selectedOption);
            });
        };

        this.clear = () => {
            if (this.listElement) {
                this.listElement.innerHTML = "";
                this.listElement = null;
            }
        };

        this.setCurrentIndex = (index) => {
            if (this.listElement) {
                this.listElement.selectedIndex = index;
                const matchedOption = this.listElement.querySelector(`option[data-index="${index}"]`);
                if (matchedOption) {
                    onChangeCb(matchedOption);
                }
            }
        };

        this.setSelectedId = (id) => {
            const matchedOption = this.listElement.querySelector(`[data-id="${id}"]`);
            if (matchedOption) {
                onChangeCb(matchedOption);
            }
        };

        this.dispose = () => this.clear();

    }
}
